export const scrollToTabs = () => {
  requestAnimationFrame(() => {
    document.getElementById('product-page-tabordion')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  })
}
